import { ref } from 'vue';
import { defineStore } from 'pinia';
import { SetupStoreId } from '@/store/plugins';
import { setLocale, getDefaultLocale } from '@/locales';
import { setDayjsLocale } from '@/locales/dayjs';

export const useAppStore = defineStore(SetupStoreId.App, () => {
  /** 重新加载页面的标志 */
  const reloadFlag = ref(true);

  /** 当前语言 */
  const locale = ref<App.I18n.LangType>(getDefaultLocale());

  /** 语言选项 */
  const localeOptions: App.I18n.LangOption[] = [
    { label: 'English', key: 'en-US' },
    { label: '中文', key: 'zh-CN' },
    { label: 'Español', key: 'es-ES' }
  ];

  /**
   * 重新加载页面
   * 
   * @param duration 重新加载的持续时间
   */
  async function reloadPage(duration = 0) {
    reloadFlag.value = false;

    if (duration) {
      await new Promise(resolve => {
        setTimeout(() => {
          resolve(true);
        }, duration);
      });
    }

    reloadFlag.value = true;
  }

  /** 
   * 切换语言
   * @param lang - 语言类型
   */
  function changeLocale(lang: App.I18n.LangType) {
    locale.value = lang;
    setLocale(lang); // 来自@/locales
    setDayjsLocale(lang); // 来自@/locales/dayjs
  }

  return {
    reloadFlag,
    locale,
    localeOptions,
    changeLocale,
    reloadPage
  };
}); 